const layout1Settings = {
  searchBox: { open: false },
  leftSidebar: { open: true, secondaryNavOpen: false }
};

export default layout1Settings;
